import { PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { standaloneUsageTracker } from './usageTrackingUtils';
export const trackPropertyEditsForObjectUpdate = ({
  objectTypeId,
  objectId,
  savedPropertyValues,
  getAdditionalPropertyValue
}) => {
  if (objectTypeId === PRODUCT_TYPE_ID) {
    var _savedPropertyValues$, _savedPropertyValues$2, _savedPropertyValues$3;
    const editedPropertyKeys = Object.keys(savedPropertyValues);
    standaloneUsageTracker.track('customer-data-properties', 'Product Lifecycle', {
      action: 'Update Product',
      status: (_savedPropertyValues$ = savedPropertyValues['hs_status']) !== null && _savedPropertyValues$ !== void 0 ? _savedPropertyValues$ : getAdditionalPropertyValue('hs_status', objectId, objectTypeId),
      billingFrequency: (_savedPropertyValues$2 = savedPropertyValues['recurringbillingfrequency']) !== null && _savedPropertyValues$2 !== void 0 ? _savedPropertyValues$2 : getAdditionalPropertyValue('recurringbillingfrequency', objectId, objectTypeId),
      editedProperties: editedPropertyKeys,
      pricingModel: (_savedPropertyValues$3 = savedPropertyValues['hs_pricing_model']) !== null && _savedPropertyValues$3 !== void 0 ? _savedPropertyValues$3 : getAdditionalPropertyValue('hs_pricing_model', objectId, objectTypeId)
    });
  }
};